import { useEffect } from "react";
import { setAppSize } from "redux/appSlice";
import store from "redux/store";
import { getLocalStorage, setLocalStorage } from "utils/storage";

const AppLayoutProvider = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    const currentVersion = getLocalStorage("ui-version");
    const metaUi = document.getElementById("ui-version");
    const newVersion = metaUi?.getAttribute("content");
    if (currentVersion !== newVersion) {
      setLocalStorage("ui-version", newVersion || "");
    }
  }, []);

  useEffect(() => {
    let timeout: any = null;
    const appHeight = () => {
      if (timeout) clearTimeout(timeout);

      return setTimeout(() => {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const doc = document.documentElement;
        // Delay for get correct height screen
        doc.style.setProperty("--app-height", `${windowHeight}px`);
        store.dispatch(
          setAppSize({ width: windowWidth, height: windowHeight })
        );
      }, 300);
    };
    timeout = appHeight();
    window.addEventListener("resize", appHeight);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      window.removeEventListener("resize", appHeight);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children}</>;
};

export default AppLayoutProvider;
